module.exports = __webpack_public_path__ + "img/laboratorio_9-16_810.0b0eb5e9.webp";